import type { Organization, OrganizationTableRow } from "../types/organizations-api.types";
import { OrganizationStatus, Provider } from "../types/organizations-api.types";

export const transformOrganizationToTableRow = (organization: Organization): OrganizationTableRow => {
  return {
    id: organization.id,
    name: organization.name,
    email: organization.email,
    phone: organization.phone,
    status: organization.status,
    card_provider: organization.card_provider,
    created_at: organization.created_at,
    updated_at: organization.updated_at,
  };
};

export const formatOrganizationStatus = (status: OrganizationStatus): string => {
  const statusMap: Record<OrganizationStatus, string> = {
    [OrganizationStatus.ACTIVE]: "Activo",
    [OrganizationStatus.INACTIVE]: "Inactivo",
    [OrganizationStatus.SUSPENDED]: "Suspendido",
    [OrganizationStatus.PENDING]: "Pendiente",
  };
  return statusMap[status] || status;
};

// Provider brand name intentionally hidden — see CLAUDE.md rule 12.
export const formatProvider = (provider: Provider | null): string => {
  if (!provider) return "N/A";
  const providerMap: Record<Provider, string> = {
    [Provider.BLOQUE]: "Coloca Cards",
    [Provider.CRYPTO_MATE]: "Coloca Crypto",
  };
  return providerMap[provider] || provider;
};

export const getOrganizationStatusStyles = (status: OrganizationStatus): string => {
  const pillBase =
    "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold border shadow-[0_1px_2px_rgba(0,0,0,0.04)]";

  const statusStyles: Record<OrganizationStatus, string> = {
    [OrganizationStatus.ACTIVE]:
      "border-emerald-200 bg-emerald-50 text-emerald-700 dark:border-emerald-500/40 dark:bg-emerald-500/15 dark:text-emerald-100",
    [OrganizationStatus.INACTIVE]:
      "border-gray-200 bg-gray-50 text-gray-700 dark:border-gray-500/40 dark:bg-gray-500/15 dark:text-gray-100",
    [OrganizationStatus.SUSPENDED]:
      "border-red-200 bg-red-50 text-red-700 dark:border-red-500/40 dark:bg-red-500/15 dark:text-red-100",
    [OrganizationStatus.PENDING]:
      "border-orange-200 bg-orange-50 text-orange-700 dark:border-orange-500/40 dark:bg-orange-500/15 dark:text-orange-100",
  };

  return `${pillBase} ${statusStyles[status] || statusStyles[OrganizationStatus.INACTIVE]}`;
};

export const getProviderStyles = (provider: Provider | null): string => {
  const pillBase =
    "inline-flex items-center rounded-full px-3 py-1 text-xs font-semibold border shadow-[0_1px_2px_rgba(0,0,0,0.04)]";

  if (!provider) {
    return `${pillBase} border-gray-200 bg-gray-50 text-gray-700 dark:border-gray-500/40 dark:bg-gray-500/15 dark:text-gray-100`;
  }

  const providerStyles: Record<Provider, string> = {
    [Provider.BLOQUE]:
      "border-blue-200 bg-blue-50 text-blue-700 dark:border-blue-500/40 dark:bg-blue-500/15 dark:text-blue-100",
    [Provider.CRYPTO_MATE]:
      "border-purple-200 bg-purple-50 text-purple-700 dark:border-purple-500/40 dark:bg-purple-500/15 dark:text-purple-100",
  };

  return `${pillBase} ${providerStyles[provider]}`;
};
